import { render, staticRenderFns } from "./MSU.vue?vue&type=template&id=422a877e&scoped=true"
import script from "./MSU.vue?vue&type=script&lang=js"
export * from "./MSU.vue?vue&type=script&lang=js"
import style0 from "./MSU.vue?vue&type=style&index=0&id=422a877e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a877e",
  null
  
)

export default component.exports